// create has no equivalent ABAC action; it is gated by an explicit decorator
// (RequireModuleAction) rather than derived from an ABAC verdict.
export const MODULE_ACTION_LIST = ["view", "create", "update", "manage", "delete"];
